/**
 * TanStack Query hooks for `impact-integration-via-api`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	impactIntegrationViaApiQueryKeys,
	type CreateImpactIntegrationViaApiBody,
	type ListImpactIntegrationViaApiResponse,
	type ImpactIntegrationViaApiRow,
} from "./api";

export function useImpactIntegrationViaApiList(): UseQueryResult<ListImpactIntegrationViaApiResponse, Error> {
	return useQuery({
		queryKey: impactIntegrationViaApiQueryKeys.list(),
		queryFn: list,
	});
}

export function useImpactIntegrationViaApiCreate(): UseMutationResult<ImpactIntegrationViaApiRow, Error, CreateImpactIntegrationViaApiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: impactIntegrationViaApiQueryKeys.all });
		},
	});
}

export function useImpactIntegrationViaApiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: impactIntegrationViaApiQueryKeys.all });
		},
	});
}
